import { stringify } from "querystring"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTimeoutFn } from "react-use"
import { Widget } from "@typeform/embed-react"

import { CALL_PAGE } from "../common/constants"

import { Spinner } from "components/Spinner"
import { useGetBookingHash } from "modules/Call/routing"
import { resolveRedirect } from "modules/Call/ClientRedirects"
import { Analytics } from "utils/analytics"
import { useClientChangeCallStatus, useGetClientCall } from "modules/Call/queries"
import { useDidMount } from "utils/customHooks"

const typeformLoadTimeout = 5000

export function ClientHangUpPage() {
    const [typeformState, setTypeformState] = useState<"loading" | "loaded" | "error">("loading")

    const navigate = useNavigate()
    const bookingHash = useGetBookingHash(true)
    const { isFetching, data } = useGetClientCall(bookingHash, CALL_PAGE.HANG_UP, false)
    const mutation = useClientChangeCallStatus()

    const [, cancelTimeout] = useTimeoutFn(() => {
        setTypeformState("error")
    }, typeformLoadTimeout)

    const close = (force?: boolean) => {
        Analytics.after_feedback_started()
        const qs = force ? `?${stringify({ force: 1 })}` : ""
        navigate(`/my/call/ended/${bookingHash}${qs}`)
    }

    const submit = () => {
        mutation.mutate(
            { bookingHash, status: "FEEDBACK_RECEIVED" },
            {
                onSuccess: () => close(),
            }
        )
    }

    const ready = () => {
        cancelTimeout()
        setTypeformState("loaded")
    }

    useDidMount(() => Analytics.after_feedback_page_loaded())

    if (isFetching || !data) return <Spinner />

    const redirect = resolveRedirect(data.status, CALL_PAGE.HANG_UP)
    if (redirect) return redirect({ bookingHash: bookingHash })

    return (
        <div className="after-call is-flex is-align-items-center is-justify-content-center">
            {typeformState === "loading" && <Spinner className="after-call__overlay" />}
            {typeformState === "error" && (
                <div className="is-flex is-justify-content-center is-align-content-center is-flex-direction-column after-call__overlay">
                    <div>
                        Произошла ошибка загрузки опросника.
                        <br />
                        <span onClick={() => close(true)} className="after-call__link">
                            Продолжить
                        </span>
                        .
                    </div>
                </div>
            )}
            <Widget
                id="PiqVJ6AV"
                className="after-call__typeform"
                hidden={{
                    booking_id: data.booking.id.toString(),
                }}
                onReady={ready}
                onSubmit={submit}
                onClose={close}
            />
        </div>
    )
}
